import '.at{flex-shrink:0;}.ssr-plugin'
import '.aw{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.bc{height:100%;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.cq{background-color:transparent;}.ssr-plugin'
import '.cr{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.bm{position:sticky;}.ssr-plugin'
import '.cs{top:4rem;}.ssr-plugin'
import '.ct{z-index:7;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.cu{padding-bottom:1rem;}.ssr-plugin'
import '.cv{margin-bottom:1rem;}.ssr-plugin'
import '.cw{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.f{position:fixed;}.ssr-plugin'
import '.bn{top:0px;}.ssr-plugin'
import '.bs{left:0px;}.ssr-plugin'
import '.bt{right:0px;}.ssr-plugin'
import '.bu{bottom:0px;}.ssr-plugin'
import '.cx{z-index:9999;}.ssr-plugin'
import '.cy{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.b1{justify-content:flex-end;}.ssr-plugin'
import '.bd{flex:1;}.ssr-plugin'
import '.c3{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="at aw n bc c4 cq cr"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b r"
    >
      <div className="bm cs ct v cu cv cw a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="f bn bs bt bu cx v cy a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="aw a b1 cw"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bd c3">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
